<script setup>
import { useGlobalStore } from '@stores/global'

import Button from '@components/global/button.vue'

const global = useGlobalStore()
</script>
<template>
	<div class="bg-bgSecondary">
		<section class="container flex flex-col items-center gap-10 lg:flex-row lg:gap-20">
			<div class="flex flex-col gap-4 text-start">
				<span class="h9 font-light">who we are</span>
				<h4 class="mt-2 font-medium">The Greenest Thumbs on Social Media</h4>
				<p class="text">What started as a creative way to keep conversations alive has grown into a thriving community of Gardeners. Together, we share experiences, build connections, and cultivate more than just plants. Through social media, we’ve created a space where everyone can grow, learn, and feel at home.</p>
				<div class="flex flex-row flex-wrap gap-2">
					<a v-for="social in global.socials" :key="social.avatar_url" :href="social.link" :title="`${social.platform.name} - ${social.username}`" target="_blank" class="flex h-4 w-4 items-center justify-center rounded-full border border-border bg-bgMain p-5 leading-[100%]">
						<i :class="social.platform.icon" />
					</a>
				</div>
			</div>
			<div class="relative h-[400px] w-fit overflow-hidden rounded-2xl bg-bgAccent p-8 md:w-full lg:p-16">
				<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/yellow.svg" class="absolute bottom-0 left-0 right-0 h-[600px] w-[600px]" alt="" />
				<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/home/about/social.jpg" alt="" class="relative h-full w-full rounded-2xl object-cover" />
			</div>
		</section>
	</div>
</template>
